import { lazy } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import ModuleRouteGuard from "../common/components/ModuleRouteGuard";
import MainLayout from "./layouts/main-layout";
import PrivateRoute from "./private-route";

const InvoiceLayout = lazy(() => import("../common/components/InvoiceLayout"));
const EmployerInvoiceLayout = lazy(
  () => import("../common/components/InvoiceLayout/EmployerInvoiceLayout"),
);
const CoveragePlan = lazy(
  () => import("../modules/Admin/Membership/coverage-plan"),
);
const AllEmployees = lazy(
  () => import("../modules/EmployerManagement/All Employees"),
);
const EmployeeBasicDetails = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/BasicsDetails"),
);
const EmployeeCredits = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Credits"),
);
const EmployerManagementWrapper = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/EmployerManagementWrapper"),
);
const EmployeeInvoices = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Invoices"),
);
const EmployeeMemberships = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Memberships"),
);
const MembershipDetails = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Memberships/MembershipDetails"),
);
const EmployeeNotes = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Notes"),
);
const EmployeeNotifications = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Notifications"),
);
const EmployeePaymentOptions = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/PaymentOptions"),
);
const EmployerDashboard = lazy(
  () => import("../modules/EmployerManagement/dashboard"),
);
const EmployersList = lazy(
  () => import("../modules/EmployerManagement/employers"),
);
const EmployerMain = lazy(
  () => import("../modules/EmployerManagement/employers/employerMain"),
);
const AccountDetails = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/AccountDetails"),
);
const EmployerDetails = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/Employees"),
);
const EmployerEmployeeMain = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/Employees/EmployeeMain"),
);
const EmployeeUploads = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/EmployeeUploads"),
);
const DetailedRows = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/EmployeeUploads/Tabs/DetailedRows"),
);
const ProcessedRows = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/EmployeeUploads/Tabs/ProcessedRows"),
);
const InvoiceSettings = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/InvoiceSettings"),
);
const OnlineSignup = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/OnlineSignUp"),
);
const NewSignupPage = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/OnlineSignUp/NewSignupPage/newSignupPage"),
);
const PaymentOption = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/PaymentOption"),
);
const Pricing = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/Pricing"),
);
const Setting = lazy(() => import("../modules/EmployerManagement/Settings"));
const Notifications = lazy(
  () => import("../modules/EmployerManagement/Settings/Tabs/Notifications"),
);
const EmployeeNotification = lazy(
  () =>
    import("../modules/EmployerManagement/Settings/Tabs/Notifications/Employee"),
);
const EmployerNotification = lazy(
  () =>
    import("../modules/EmployerManagement/Settings/Tabs/Notifications/Employer"),
);
const TemplateView = lazy(
  () =>
    import("../modules/EmployerManagement/Settings/Tabs/Notifications/Employer/TemplateView"),
);
const Plans = lazy(
  () => import("../modules/EmployerManagement/Settings/Tabs/Plans"),
);
const ViewPlan = lazy(
  () => import("../modules/EmployerManagement/Settings/Tabs/Plans/ViewPlan"),
);
const SignupWithPHP = lazy(
  () => import("./employer-management/employers/sign-up"),
);
const BrokerMainWrapper = lazy(
  () => import("../modules/EmployerManagement/Broker"),
);
const Broker = lazy(
  () => import("../modules/EmployerManagement/Broker/Broker"),
);
const BrokerFirm = lazy(
  () => import("../modules/EmployerManagement/Broker/BrokerFirm"),
);
const BrokerInvoices = lazy(
  () => import("../modules/EmployerManagement/Broker/Invoices"),
);
const Agreement = lazy(
  () => import("../modules/EmployerManagement/Broker/Agreement"),
);
const EmployerInvoices = lazy(
  () =>
    import("../modules/EmployerManagement/employers/employerMain/Tabs/Invoices"),
);
const TicketsModule = lazy(
  () => import("../modules/EmployerManagement/Tickets"),
);
const TicketDashboard = lazy(
  () => import("../modules/EmployerManagement/Tickets/Dashboard"),
);
const TicketConversation = lazy(
  () => import("../modules/EmployerManagement/Tickets/Detail/Conversation"),
);
const TicketTasks = lazy(
  () => import("../modules/EmployerManagement/Tickets/Detail/Tasks"),
);
const TicketActivityLogs = lazy(
  () => import("../modules/EmployerManagement/Tickets/Detail/ActivityLogs"),
);
const TicketNotes = lazy(
  () => import("../modules/EmployerManagement/Tickets/Detail/Notes"),
);
const TicketsEmployersList = lazy(
  () => import("../modules/EmployerManagement/Tickets/EmployersTicket"),
);
const EmployerOverview = lazy(
  () => import("../modules/EmployerManagement/Tickets/Employers"),
);
const AllTickets = lazy(
  () => import("../modules/EmployerManagement/Tickets/Employers/AllTickets"),
);
const Tasks = lazy(
  () => import("../modules/EmployerManagement/Tickets/Employers/Tasks"),
);
const Attachments = lazy(
  () => import("../modules/EmployerManagement/Tickets/Employers/Attachments"),
);
const Notes = lazy(
  () => import("../modules/EmployerManagement/Tickets/Employers/Notes"),
);
const TicketManagement = lazy(
  () => import("../modules/EmployerManagement/Tickets/Management"),
);
const TicketList = lazy(
  () => import("../modules/EmployerManagement/Tickets/Tickets"),
);
const TicketAttachments = lazy(
  () => import("../modules/EmployerManagement/Tickets/Detail/Attachments"),
);
const LinkedTickets = lazy(
  () => import("../modules/EmployerManagement/Tickets/Detail/LinkedTickets"),
);
const TicketProvider = lazy(() =>
  import("../modules/EmployerManagement/Tickets/components/TicketContext").then(
    (m) => ({ default: m.TicketProvider }),
  ),
);
const ActivityLogs = lazy(
  () => import("../modules/EmployerManagement/Tickets/Activity/ActivitityLogs"),
);
const EmployerNotes = lazy(() => import("../modules/Billing/Notes"));
const BrokerInvoiceLayout = lazy(
  () => import("../common/components/InvoiceLayout/BrokerInvoiceLayout"),
);

const MainRoute = () => (
  <PrivateRoute>
    <MainLayout>
      <Outlet />
    </MainLayout>
  </PrivateRoute>
);

const EmployerManagementRoutes = (
  <Route path="/employer" element={<MainRoute />}>
    <Route
      path="all-employees/:id/invoice/:invoiceUuid/:mode?"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="invoices">
          <InvoiceLayout />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="dashboard"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="dashboard"
        >
          <EmployerDashboard />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employers"
        >
          <EmployersList feature="EM Employers" />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="all-employees"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="all-employees"
        >
          <AllEmployees feature="EM All employees" />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="all-employees/sign-up/:employeeUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="all-employees"
        >
          <SignupWithPHP />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="all-employees/sign-up"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="all-employees"
        >
          <SignupWithPHP />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/sign-up/:employeeUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employers"
        >
          <SignupWithPHP />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="coverage-plans/"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="coverage-plans"
        >
          <CoveragePlan />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/sign-up"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employers"
        >
          <SignupWithPHP />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="broker"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="brokers">
          <BrokerMainWrapper />
        </ModuleRouteGuard>
      }
    >
      <Route index element={<Navigate to="firm" replace />} />
      <Route
        path="broker"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="brokers"
          >
            <Broker />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="firm"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="brokers"
          >
            <BrokerFirm />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="invoices"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="invoices"
          >
            <BrokerInvoices feature="Billing Employer Invoices" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="agreement"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="brokers"
          >
            <Agreement />
          </ModuleRouteGuard>
        }
      />
    </Route>
    <Route
      path="broker-firm/:firmUuid/invoice/:invoiceUuid/edit"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="invoices">
          <BrokerInvoiceLayout />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="settings/"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="settings">
          <Setting />
        </ModuleRouteGuard>
      }
    >
      <Route
        path="plans"
        element={
          <ModuleRouteGuard moduleType="employer-management" routePath="plans">
            <Plans />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="broker"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="brokers"
          >
            <Broker />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="agent-firm"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="brokers-firm"
          >
            <BrokerFirm />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notifications/"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="notifications"
          >
            <Notifications />
          </ModuleRouteGuard>
        }
      >
        <Route index element={<Navigate to="employer" replace />} />
        <Route
          path="employer"
          element={
            <ModuleRouteGuard
              moduleType="employer-management"
              routePath="notifications"
            >
              <EmployerNotification />
            </ModuleRouteGuard>
          }
        />
        <Route
          path="employee"
          element={
            <ModuleRouteGuard
              moduleType="employer-management"
              routePath="notifications"
            >
              <EmployeeNotification />
            </ModuleRouteGuard>
          }
        />
        <Route path="*" element={<Navigate to="employer" replace />} />
      </Route>
      <Route
        path="notifications-template-employer/:uuid"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="notifications"
          >
            <TemplateView />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notifications-template-employer/:uuid/customize"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="notifications"
          >
            <TemplateView />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="plans-details/:id"
        element={
          <ModuleRouteGuard moduleType="employer-management" routePath="plans">
            <ViewPlan />
          </ModuleRouteGuard>
        }
      />
    </Route>
    <Route
      path="plans-details/:id"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="plans">
          <ViewPlan />
        </ModuleRouteGuard>
      }
    />

    <Route
      path="employers/:employerUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employers"
        >
          <EmployerMain />
        </ModuleRouteGuard>
      }
    >
      <Route index element={<Navigate to="employees" replace />} />
      <Route
        path="invoices"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employees"
          >
            <EmployerInvoices feature="Billing Employer Invoices" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="employees"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employees"
          >
            <EmployerDetails feature="EM Employees" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="account-details"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="account-details"
          >
            <AccountDetails feature="EM Account Details" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="pricing"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="pricing"
          >
            <Pricing feature="EM Pricing" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="pricing/plans-details/:id"
        element={
          <ModuleRouteGuard moduleType="employer-management" routePath="plans">
            <ViewPlan />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="online-signup"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="online-signup"
          >
            <OnlineSignup />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="payment-option"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employer-payment-option"
          >
            <PaymentOption feature="EM Employer Payment Option" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notes"
        element={
          <ModuleRouteGuard moduleType="employer-management" routePath="notes">
            <EmployerNotes feature="EM Notes" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="employee-uploads"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employee-uploads"
          >
            <EmployeeUploads feature={"EM Employee Uploads"} />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="invoice-settings"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="invoice-settings"
          >
            <InvoiceSettings feature={"EM Invoice Settings"} />
          </ModuleRouteGuard>
        }
      />
    </Route>
    <Route
      path="employers/:employerUuid/new-signup-page"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="online-signup"
        >
          <NewSignupPage />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/new-signup-page/:employerPageUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="online-signup"
        >
          <NewSignupPage />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/employee-uploads/:uploadUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employee-uploads"
        >
          <ProcessedRows />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/employee-uploads/:uploadUuid/view-all"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employee-uploads"
        >
          <DetailedRows />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/employees/:employeeUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="employees"
        >
          <EmployerEmployeeMain />
        </ModuleRouteGuard>
      }
    >
      <Route index element={<Navigate to="employee-details" replace />} />
      <Route
        path="employee-details"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="all-employees"
          >
            <EmployeeBasicDetails feature="EM Basic Details" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="invoices"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="invoices"
          >
            <EmployeeInvoices feature="EM Invoices" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="credits"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="credits"
          >
            <EmployeeCredits feature="EM Credits" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="memberships"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="memberships"
          >
            <EmployeeMemberships feature="EM Memberships" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="payment-options"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employee-payment-option"
          >
            <EmployeePaymentOptions feature="EM Employee Payment Option" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notes"
        element={
          <ModuleRouteGuard moduleType="employer-management" routePath="notes">
            <EmployeeNotes feature="EM Notes" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notifications"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employee-notifications"
          >
            <EmployeeNotifications feature="EM Employee Notifications" />
          </ModuleRouteGuard>
        }
      />
    </Route>
    <Route
      path="employers/:employerUuid/employees/:employeeUuid/invoice/:invoiceUuid/:mode?"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="invoices">
          <InvoiceLayout />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/invoice/:invoiceUuid/:mode?"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="invoices">
          <EmployerInvoiceLayout />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="all-employees/:employeeUuid"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="all-employees"
        >
          <EmployerManagementWrapper />
        </ModuleRouteGuard>
      }
    >
      <Route index element={<Navigate to="employee-details" replace />} />
      <Route
        path="employee-details"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="all-employees"
          >
            <EmployeeBasicDetails feature="EM Basic Details" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="invoices"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="invoices"
          >
            <EmployeeInvoices feature="EM Invoices" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="credits"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="credits"
          >
            <EmployeeCredits feature="EM Credits" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="memberships"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="memberships"
          >
            <EmployeeMemberships feature="EM Memberships" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="payment-options"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employee-payment-option"
          >
            <EmployeePaymentOptions feature="EM Employee Payment Option" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notes"
        element={
          <ModuleRouteGuard moduleType="employer-management" routePath="notes">
            <EmployeeNotes feature="EM Notes" />
          </ModuleRouteGuard>
        }
      />
      <Route
        path="notifications"
        element={
          <ModuleRouteGuard
            moduleType="employer-management"
            routePath="employee-notifications"
          >
            <EmployeeNotifications feature="EM Employee Notifications" />
          </ModuleRouteGuard>
        }
      />
    </Route>
    <Route
      path="all-employees/:employeeUuid/membership-details"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="memberships"
        >
          <MembershipDetails feature="EM Memberships" />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="employers/:employerUuid/employees/:employeeUuid/membership-details"
      element={
        <ModuleRouteGuard
          moduleType="employer-management"
          routePath="memberships"
        >
          <MembershipDetails feature="EM Memberships" />
        </ModuleRouteGuard>
      }
    />
    <Route
      path="tickets"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="employer">
          <TicketProvider>
            <TicketsModule />
          </TicketProvider>
        </ModuleRouteGuard>
      }
    >
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<TicketDashboard />} />
      <Route path="/employer/tickets">
        <Route index element={<Navigate to="list/open" replace />} />
        <Route path="list">
          <Route index element={<Navigate to="open" replace />} />
          <Route path=":status" element={<TicketList />} />
        </Route>
      </Route>

      <Route path=":ticketId" element={<TicketManagement />}>
        <Route index element={<Navigate to="conversation" replace />} />
        <Route path="conversation" element={<TicketConversation />} />
        <Route path="tasks" element={<TicketTasks />} />
        <Route path="activity-logs" element={<TicketActivityLogs />} />
        <Route path="notes" element={<TicketNotes />} />
        <Route path="attachments" element={<TicketAttachments />} />
        <Route path="linked-tickets" element={<LinkedTickets />} />
      </Route>
      <Route path="activity" element={<ActivityLogs />} />
      <Route path="employers" element={<TicketsEmployersList />} />
      <Route path="employers/:employerId" element={<EmployerOverview />}>
        <Route index element={<Navigate to="all-tickets" replace />} />
        <Route path="all-tickets" element={<AllTickets />} />
        <Route path="activity" element={<TicketActivityLogs />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="attachments" element={<Attachments />} />
        <Route path="notes" element={<Notes />} />
      </Route>
    </Route>

    <Route
      path="management/:ticketId"
      element={
        <ModuleRouteGuard moduleType="employer-management" routePath="tickets">
          <TicketManagement />
        </ModuleRouteGuard>
      }
    >
      <Route index element={<Navigate to="activity-logs" replace />} />
      <Route path="conversation" element={<TicketConversation />} />
      <Route path="tasks" element={<TicketTasks />} />
      <Route path="activity-logs" element={<TicketActivityLogs />} />
      <Route path="notes" element={<TicketNotes />} />
      <Route path="attachments" element={<TicketAttachments />} />
      <Route path="linked-tickets" element={<LinkedTickets />} />
    </Route>
  </Route>
);

export default EmployerManagementRoutes;
